import type { ReactNode } from "react";

export const generateLabelName = (name: ReactNode, required: boolean) =>
  required ? <>* {name}</> : <>{name}</>;
